
    <div class="main-wrapper">
    <div class="navigation-wrapper">
    <div class="heading">
    <h1>Welcome to the largest <br/> situational awareness platform <br/></h1>
  </div>

    </div> 
    
      <div class="main-page">
      <main class="flex-shrink-0 container" [ngStyle]="{'justify-content': selectedPlan || isAuthRoute ? 'flex-end' : 'center' }">
      <div [ngClass]="selectedPlan || isAuthRoute ? 'right' : 'center'">
        <div class="container-form">
          <router-outlet></router-outlet>
        </div>
      </div>
      </main>
      <footer class="footer">
      <app-footer></app-footer>
       </footer>
    
      
    </div>

    
  </div>
